export default __webpack_public_path__ + "static/media/invalidLink.6f20259d.svg";